export default __webpack_public_path__ + "static/media/octa_split.55d7ed6b.png";